import React, { useState } from "react";
// import "./MonthlyReportsFormEdit.css";
// import { Form,Button } from "react-bootstrap";
import { Form, Button, Col, Row } from "react-bootstrap";
import axios from "axios";
import Rq from "../../NewComponents/RQ";
import DocUploadEdit from "../DocUpload/DocUploadEdit";
import { MonthYearData } from "../../../shared/util/vars";

function MonthlyReportsForm(props) {
  const [RQData, setRQData] = useState(props.editData["Text"]);
  const [ReportYearMonth, setReportYearMonth] = useState(
    props.editData["monthyear"]
  );
  const [FileLink, setFileLink] = useState(props.editData["FileLinks"]);
  const [File, setFile] = useState("");

  const HandleRQData = (txt) => {
    setRQData(txt);
  };
  const HandleReportMonthYear = (e) => {
    setReportYearMonth(e.target.value);
  };
  const HandleFileLink = (e) => {
    setFileLink(e.target.value);
  };

  const onSubmission = () => {
    const d = new Date();
    let day = String(d);

    let Editbody = {
      editID: props.editData._id,
      monthyear: ReportYearMonth,
      FileLinks: FileLink,
      EditDate: day,
      Text: RQData,
    };

    console.log("trying to Edit");
    props.onMonthlyReportsEditUpdate(Editbody);
  };

  return (
    <div>
      <h2 id="role-form-title">Edit MonthlyReports Details</h2>

      <div id="role-form-outer-div">
        <Form id="form">
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Select Month & Year
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control
                as="select"
                required
                onChange={HandleReportMonthYear}
                value={ReportYearMonth}>
                {MonthYearData.map((options, id) => (
                  <option key={id} value={options.value}>
                    {options.option}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              File URL
            </Form.Label>
            <Col sm={7} className="form-input">
              <Form.Control
                disabled
                type="Text"
                placeholder="FilePath "
                required
                value={FileLink}
              />
            </Col>
            <Col sm={3} className="form-input">
              <DocUploadEdit
                center
                id="document"
                HandleOtherText={props.HandleOtherText}
                File={FileLink}
                setFile={setFileLink}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Report Text
            </Form.Label>
            <Col sm={10} className="form-input">
              <Rq HandleRQText={HandleRQData} RQ={RQData} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} id="form-submit-button">
            <Col sm={{ span: 10, offset: 2 }}>
              <Button onClick={onSubmission}>Update</Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row} id="form-cancel-button">
            <Col sm={{ span: 10, offset: 2 }} id="form-cancel-button-inner">
              <Button type="reset" onClick={props.onFormEditClose}>
                cancel
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
}

export default MonthlyReportsForm;
